export enum FeatureFlags {
  DOT_144_USER_DASHBOARD_REDESIGN = 'DOT-144-user-dashboard-redesign',
  DOT_191_BOOK_APPOINTMENT = 'DOT-191-book-appointment',
  SC_369_MARKETING_PREFERENCES_CHANGES = 'SC-369-marketing-preferences-changes',
  A2P_188_NEW_PRACTITIONER_PROFILE_LINK = 'A2P-188-new-practitioner-profile-link',
  A2P_616_ON_DEMAND_MIGRATION_TO_MEDWORLD_PROFILE = 'A2P-616-on-demand-user-migration-to-medworld-profile',
  A2P_2811_ADD_AHPRA_CHECK_TO_AU_JOB_ENQUIRY = 'A2P-2811-add-ahpra-check-to-au-job-enquiry',
  A2P_2939_REFER_FRIEND_NEW_PAGE = 'A2P-2939-refer-friend-new-page',
}
